import React from 'react';
import { useCurrentSubscription } from '@/hooks/useCurrentSubscription';
import { useOrganizationEntitlements, ALWAYS_ENABLED_FEATURES } from '@/hooks/useFeatureLimits';

const SAFETY_MS = 1500;

export function useEntitlementsSettled(enabled: boolean = true): boolean {
  const { data: entitlements, isError: entitlementsError } = useOrganizationEntitlements();
  const { data: rawSubscription } = useCurrentSubscription({ enabled });
  const [settled, setSettled] = React.useState(false);

  React.useEffect(() => {
    if (!enabled) return;
    if (settled) return;
    if (entitlementsError) { setSettled(true); return; }
    if (rawSubscription === undefined) return;
    const featureMap = entitlements?.entitlements?.features || {};
    const hasPlanFeature = Object.keys(featureMap).some(
      (k) => !(k in ALWAYS_ENABLED_FEATURES),
    );
    if (rawSubscription === null || hasPlanFeature) { setSettled(true); return; }
    const t = setTimeout(() => setSettled(true), SAFETY_MS);
    return () => clearTimeout(t);
  }, [entitlements, rawSubscription, entitlementsError, settled, enabled]);

  return !enabled ? true : settled;
}
